

export const booleanSubrowColumn = ({
  header,
  accessorKey,
  trueLabel = "Sí",
  falseLabel = "No",
  trueValue = "si",
  falseValue = "no",
  cellRenderer,
} = {}) => ({
  header,
  accessorKey,
  filterVariant: "select",
  filterSelectOptions: [
    { text: trueLabel, value: trueValue },
    { text: falseLabel, value: falseValue },
  ],
  filterFn: (row, columnId, filterValue) => {
    if (!filterValue) return true;
    const cellValue = !!row.getValue(columnId);
    if (filterValue === "si") return cellValue === true;
    if (filterValue === "no") return cellValue === false;
    return true;
  },
  maxSize: 100,
  minSize: 80,
  Cell: (({ row, column }) => {
    const parent = row.getParentRow();
    if (!parent) return "";
    return row.getValue(column.id) ? trueLabel : falseLabel

  }),
  enableColumnFilter: true,
});
